import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell, TableFooter } from "@material-ui/core";
import useTable from "../useTable";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { AgregarReten } from "./modalAgregarReten";
import moment from "moment";
import { formatMoneda } from "../../util/varios";
import CatalogoAgenteTipoEspecifico from "../../catalogos/catalogoAgenteTipoEspecifi";
import TablaHistoricoReten from "./tablaHistorico";
import { validarCamposArchivo, cargarCamposArchivo } from "../../util/varios";
import { Dimmer } from "../spinner";

function Retenciones() {
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [fechas, setFechas] = useState();
  const [banco, setBanco] = useState();
  const [anio, setAnio] = useState([]);
  const [agente, setAgente] = useState("");
  const [catalogo, setCatalogo] = useState(false);
  const [records, setRecords] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [operacion, setOperacion] = useState();
  const [retenciontemp, setRetenciontemp] = useState();
  const [visibleF, setVisibleF] = useState("hidden");
  const [visibleA, setVisibleA] = useState("hidden");
  const [select, setSelect] = useState("0");
  const [mensajact, setMensajeact] = useState();
  const [teclas, setTeclas] = useState();
  const [desde, setDesde] = useState(0);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState({
    idagente: false,
  });
  const [valuess, setValuess] = useState({
    idagente: "",
    nombre: "",
    direccion: "",
    rif: "",
    nrolicencia1x500: "",
    nroresolucion1x500: "",
    reprelegal: "",
    telefono: "",
    fechainscripcion1x500: "",
    status1x500: "",
    idtipoagente: "",
    observacionstatus1x500: null,
    credito: 0.0,
    email: "",
    exonintereses1x500: false,
    exonmultas1x500: false,
    exonrecargos1x500: false,
    ciudad: "",
    municipio: "",
  });
  const [activate, setActivate] = useState(false);
  const [msgArchivo, setMsgArchivo] = useState();
  const [datosArchivo, setDatosArchivo] = useState(0);
  const [agenteRetencion, setAgenteRetencion] = useState(false);
  const [retencion, setRetencion] = useState();
  const [habilitadoBot, setHabilitadoBot] = useState(false);
  const [totalretenido, setTotalRetenido] = useState("0,00");
  const [cantidad, setCantidad] = useState(0);

  const txtAgente = useRef();
  const txtSelect = useRef();
  const txtAnio = useRef();
  const txtMes = useRef();
  const btnAcepta = useRef();
  const txtFile = useRef();

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° Operación",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Tipo de Instrumento",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° de Instrumento",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CED. / RIF.",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Nombre o Razón Social",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Fecha de Emisión",
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto Bruto",
      textAlign: "center",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Impuesto 1x1000",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "",
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead } = useTable(records, headCells, {
    fn: (items) => {
      return items;
    },
  });

  const onChange = (event) => {
    setMsgArchivo("");
    setRetencion([]);
    setDatosArchivo(0);
    let anio = txtAnio.current.value;
    if (event.target.name === "idagente") {
      setHistorico([]);
      setValuess({
        idagente: "",
        nombre: "",
        direccion: "",
        rif: "",
        nrolicencia1x500: "",
        nroresolucion1x500: "",
        reprelegal: "",
        telefono: "",
        fechainscripcion1x500: "",
        status1x500: "",
        idtipoagente: "",
        observacionstatus1x500: null,
        credito: 0.0,
        email: "",
        exonintereses1x500: false,
        exonmultas1x500: false,
        exonrecargos1x500: false,
        ciudad: "",
        municipio: "",
      });
      setMensajeact("");
    } else if (event.target.name === "anio") {
      onValidaFecha();
      txtMes.current.value = "";
      txtSelect.current.value = "";
      setVisibleA("hidden");
      setSelect("0");
      seleccionarRegistro();
    } else if (event.target.name === "mes") {
      onValidaFecha();
      const selectedIndex = event.target.options.selectedIndex;
      let fc = selectedIndex;
      setFechas(fc + "-" + anio);
      let mes = txtMes.current.value;
      if (txtMes.current.value !== mes) {
        txtSelect.current.value = "";
        setVisibleA("hidden");
        setSelect("0");
        seleccionarRegistro();
      }
    } else if (event.target.name === "select") {
      if (event.target.value === "1") {
        let selector = txtSelect.current.value;
        seleccionarRegistro();
        setVisibleA("visible");
        setSelect(selector);
        let meses = txtMes.current.value;
        if (meses === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Mes para poder Carga la Retención",
            icono: "informacion",
          });
          setVisibleA("hidden");
          setSelect("0");
          txtSelect.current.value = "";
          txtMes.current.focus();
        } else if (anio === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Año para poder Carga la Retención",
            icono: "informacion",
          });
          setVisibleA("hidden");
          setSelect("0");
          txtSelect.current.value = "";
          txtMes.current.value = "";
          txtAnio.current.focus();
        } else {
          setDeshabilitado(false);
        }
      } else if (event.target.value === "2") {
        let selector = txtSelect.current.value;
        setVisibleA("hidden");
        setSelect(selector);
        let meses = txtMes.current.value;
        if (meses === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Mes para poder Carga la Retención",
            icono: "informacion",
          });
          setVisibleA("hidden");
          setSelect("0");
          txtSelect.current.value = "";
        } else if (anio === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Año para poder Carga la Retención",
            icono: "informacion",
          });
          setVisibleA("hidden");
          setSelect("0");
          txtSelect.current.value = "";
          txtMes.current.value = "";
          txtAnio.current.focus();
        } else {
          setDeshabilitado(true);
        }
      } else if (event.target.value === "") {
        let selector = txtSelect.current.value;
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar el Tipo de Carga de la Retención",
          icono: "informacion",
        });
        let meses = txtMes.current.value;
        setSelect(selector);
        if (meses === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Mes para poder Carga la Retención",
            icono: "informacion",
          });
          setVisibleA("hidden");
          setSelect("0");
          txtSelect.current.value = "";
        } else if (anio === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Año para poder Carga la Retención",
            icono: "informacion",
          });
          setVisibleA("hidden");
          setSelect("0");
          txtSelect.current.value = "";
          txtMes.current.value = "";
          txtAnio.current.focus();
        }
        setVisibleA("hidden");
        setSelect("0");
      } else {
        setVisibleA("hidden");
        setSelect("0");
      }
    }
    if (txtAnio.current.value !== "" && txtMes.current.value !== "") {
      let his = historico;
      let per =
        txtMes.current.value.trim().padStart(2, "0") +
        "-" +
        txtAnio.current.value.trim();
      for (let i = 0; i < his.length; i++) {
        if (his[i].periodo === per) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto:
              "Las Retenciones del Período " + per + " ya fueron declaradas.",
            icono: "error",
          });
          txtSelect.current.value = "";
          txtMes.current.value = "";
          txtAnio.current.value = "";
          txtAnio.current.focus();
        }
      }
    }
  };

  const seleccionarRegistro = () => {
    let peri =
      txtMes.current.value.trim().padStart(2, "0") +
      "-" +
      txtAnio.current.value.trim();
    let endpoint = `${op.conexion}/api/retencion/seleccionartemp?&agente=${agente}&periodo=${peri}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          var totRete = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            totRete = totRete + parseFloat(response.data[i].montoretenido);
          }
          totRete = formatMoneda(
            totRete.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          setTotalRetenido(totRete);

          setRecords(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarHistorico = (agente) => {
    let endpoint = `${op.conexion}/api/retencion/seleccionarhist?&agente=${agente}&fechasis=${fechaSistema}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setHistorico(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "impuesto1x500";

    let endpoint = `${
      op.conexion
    }/api/retencion/seleccionaragente?&campos=${campos}&id=${idagente}&nomid=${nomid}&nomtab=${nomtab}&nomid2=${nomid2}&id2=${true}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtAgente.current.value = response.data.idagente;
            valuess.status1x500 = response.data.status1x500;
            valuess.rif = response.data.rif;
            valuess.nombre = response.data.nombre;
            valuess.direccion = response.data.direccion;
            if (response.data.status1x500 === "51") {
              setVisibleF("visible");
              setMensajeact(
                <p className="text-success fw-bold">
                  &nbsp;ACTIVO <i className="fas fa-user-check" />
                </p>
              );
              setAgente(txtAgente.current.value);
              if (txtAgente.current.value !== valuess.idagente) {
                setVisibleA("hidden");
                setSelect("0");
                txtSelect.current.value = "";
                txtAnio.current.value = "";
                txtMes.current.value = "";
              }
            } else {
              txtSelect.current.value = "";
              txtMes.current.value = "";
              txtAnio.current.value = "";
              setVisibleF("hidden");
              setVisibleA("hidden");
              setSelect("0");
              setMensajeact(
                <p className="text-danger fw-bold">
                  &nbsp;INACTIVO <i className="fas fa-user-times" />
                </p>
              );
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
                icono: "error",
              });
            }
            seleccionarHistorico(txtAgente.current.value);
          } else {
            if (teclas === 13) {
              setTimeout(() => {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "Código/Agente no Existe...",
                  icono: "error",
                });
                txtSelect.current.value = "";
                txtMes.current.value = "";
                txtAnio.current.value = "";
                txtAgente.current.value = "";
                valuess.status1x500 = "";
                valuess.rif = "";
                valuess.nombre = "";
                valuess.direccion = "";
                setMensajeact("");
                setVisibleF("hidden");
                setVisibleA("hidden");
                setSelect("0");
                txtAgente.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistros = (idretenciontemp) => {
    let campos = "*";
    let nomtab = "retencionestemp1x500";
    let nomid = "idretenciontemp";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idretenciontemp}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idretenciontemp > 0) {
            setRetenciontemp(response.data);
            //seleccionarBanco(response.data);
            setMostrar2(true);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  /*   const seleccionarBanco = (data) => {
    let campos = "*";
    let nomtab = "bancos";
    let nomid = "idbanco";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.banco}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idbanco > 0) {
            setBanco(response.data);

            setMostrar2(true);
          } else {
            setMostrar2(true);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  }; */

  const procesarRetencionesManual = (body) => {
    let endpoint = `${op.conexion}/api/retencion/actualizarretencionmanual`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data) {
            const periodo =
              txtMes.current.value.padStart(2, "0") +
              "-" +
              txtAnio.current.value;
            const msg = "";

            if (records.length > 0) {
              window.open(
                op.reportes +
                  "&IDAGENTE=" +
                  txtAgente.current.value +
                  "&PERIODO=" +
                  "'" +
                  periodo +
                  "'" +
                  "&FECHASISTEMA=" +
                  "'" +
                  fechaSistema +
                  "'" +
                  "&reporte=Retenciones",
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
              );
              msg =
                "Las restenciones para el periodo " +
                periodo +
                " se registraron de manera satisfactoria.";
            } else {
              window.open(
                op.reportes +
                  "IDAGENTE=" +
                  txtAgente.current.value +
                  "&PERIODO=" +
                  periodo +
                  "&reporte=Comprobante",
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
              );
              msg =
                "El período " +
                periodo +
                " se procesó correctamente sin retenciones!";
            }

            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Procesar Retenciones",
              texto: msg,
              icono: "exito",
            });
            seleccionarRegistro();
            seleccionarHistorico(txtAgente.current.value);
            txtAnio.current.value = "";
            txtMes.current.value = "";
            txtSelect.current.value = "";
            txtAnio.current.focus();
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRetencionesArchivo = (body) => {
    let endpoint = `${op.conexion}/api/retencion/actualizarretencionarchivo`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data) {
            const msg = "";
            const periodo =
              txtMes.current.value.padStart(2, "0") +
              "-" +
              txtAnio.current.value;
            window.open(
              op.reportes +
                "&IDAGENTE=" +
                txtAgente.current.value +
                "&PERIODO=" +
                "'" +
                periodo +
                "'" +
                "&FECHASISTEMA=" +
                "'" +
                fechaSistema +
                "'" +
                "&reporte=Retenciones",
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
            msg =
              "Las restenciones para el periodo " +
              periodo +
              " se registraron de manera satisfactoria.";
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Procesar Retenciones",
              texto: msg,
              icono: "exito",
            });
            seleccionarHistorico(txtAgente.current.value);
            txtAnio.current.value = "";
            txtMes.current.value = "";
            txtSelect.current.value = "";
            txtAnio.current.focus();
            setRetencion([]);
            setDatosArchivo(0);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRetencion = () => {
    let seguir = true;
    if (txtAnio.current.value === "") {
      seguir = false;
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Seleccionar el Año para Continuar con la Operación",
        icono: "error",
      });
      txtAnio.current.focus();
      return;
    } else if (txtMes.current.value === "") {
      seguir = false;
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Seleccionar el Mes para Continuar con la Operación",
        icono: "error",
      });
      txtMes.current.focus();
      return;
    } else if (select === "0") {
      seguir = false;
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Seleccionar el Tipo de Carga de la Retención",
        icono: "error",
      });
      txtSelect.current.focus();
      return;
    }

    if (seguir) {
      if (select === "1") {
        if (records.length === 0) {
          setDesde(2);
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto:
              "No posee retenciones cargadas, desea procesar el período sin retenciones?",
            icono: "confirmacion",
          });
        } else {
          setDesde(2);
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto:
              "Esta seguro de Procesar estas Retenciones? se generara una deuda con el Monto Total",
            icono: "confirmacion",
          });
        }
      } else {
        setDesde(2);
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto:
            "Esta seguro de Procesar estas Retenciones? se generara una deuda con el Monto Total?",
          icono: "confirmacion",
        });
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTeclas(event.which);
        datosAgente(event.target.value);
      } else {
        txtAgente.current.value = "";
      }
    }
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActivate(true);
    if (select === "1") {
      let body = {
        txtagente: txtAgente.current.value,
        txtmes: txtMes.current[txtMes.current.selectedIndex].text,
        nmes: txtMes.current.value,
        txtanio: txtAnio.current.value,
        fechasis: fechaSistema,
      };
      procesarRetencionesManual(body);
    } else {
      var tipo = [];
      var rif = [];
      var nombre = [];
      var periodo = [];
      var numcontrol = [];
      var monbruto = [];
      var monrete = [];
      for (let i = 0; i < retencion.length; i++) {
        tipo.push(retencion[i].tipoins);
        rif.push(retencion[i].cedrif);
        nombre.push(retencion[i].nombre);
        periodo.push(
          txtMes.current.value.padStart(2, "0") + "-" + txtAnio.current.value
        ),
          numcontrol.push(retencion[i].numins);
        monbruto.push(
          retencion[i].monbruto.toString().replace(/\./g, "").replace(",", ".")
        );
        monrete.push(
          retencion[i].monrete.toString().replace(/\./g, "").replace(",", ".")
        );
      }

      let body = {
        txtagente: txtAgente.current.value,
        txtmes: txtMes.current[txtMes.current.selectedIndex].text,
        nmes: txtMes.current.value,
        txtanio: txtAnio.current.value,
        fechasis: fechaSistema,
        txttipo: tipo,
        txtcontrol: numcontrol,
        txtrif: rif,
        txtrazon: nombre,
        txtmontob: monbruto,
        txtperiodo: periodo,
        txtretenido: monrete,
      };
      procesarRetencionesArchivo(body);
    }
  };

  const gestionarRetencion = (op, id) => (e) => {
    if (op === 1) {
      setOperacion(1);
      setMostrar2(true);
    } else if (op === 3) {
      setDatosArchivo(0);
      setOperacion(op);
      seleccionarRegistros(id);
    }
  };

  const onFecha = () => {
    var nanio = [];
    var aini = parseInt(anioActu) - 7;
    var afin = parseInt(anioActu);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
  };

  const onFocus = (e) => {
    setHabilitadoNU({ ...habilitadoNU, [e.target.name]: true });
  };

  const onHideAceptaCatAge = (
    idage,
    nombage,
    status1x500,
    direccion,
    numre,
    numli,
    rif
  ) => {
    setCatalogo(false);
    txtAgente.current.value = idage;
    valuess.nombre = nombage !== null ? nombage.trim() : "";
    valuess.status1x500 = status1x500;
    valuess.direccion = direccion !== null ? direccion : "";
    valuess.nroresolucion1x500 = numre !== null ? numre.trim() : "";
    valuess.nrolicencia1x500 = numli !== null ? numli.trim() : "";
    valuess.rif = rif !== null ? rif.trim() : "";
    if (txtAgente.current.value > 0) {
      seleccionarHistorico(txtAgente.current.value);
      if (valuess.status1x500 === "51") {
        setVisibleF("visible");
        setMensajeact(
          <p className="text-success fw-bold">
            &nbsp;ACTIVO <i className="fas fa-user-check" />
          </p>
        );
        setAgente(txtAgente.current.value);
        if (txtAgente.current.value !== valuess.idagente) {
          setVisibleA("hidden");
          setSelect("0");
          txtSelect.current.value = "";
          txtAnio.current.value = "";
          txtMes.current.value = "";
        }
      } else {
        txtSelect.current.value = "";
        txtMes.current.value = "";
        txtAnio.current.value = "";
        setVisibleF("hidden");
        setVisibleA("hidden");
        setSelect("0");
        setMensajeact(
          <p className="text-danger fw-bold">
            &nbsp;INACTIVO <i className="fas fa-user-times" />
          </p>
        );
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
      }
    }
  };

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const onValidaFecha = () => {
    if (txtAnio.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Año para Continuar con la Operación",
        icono: "informacion",
      });
      txtMes.current.value = "";
      txtAnio.current.focus();
    }
  };

  useEffect(() => {
    onFecha();
  }, []);

  const handleChangeFile = (event) => {
    var archivo = event.target.files[0];
    if (!archivo) {
      return;
    }
    var lector = new FileReader();

    lector.readAsText(archivo);
    lector.onload = function (e) {
      var contenido = e.target.result;
      var lineas = contenido.split("\n");
      setActivate(true);
      var resp = validarCamposArchivo(lineas);
      if (resp[0] === false) {
        txtFile.current.value = "";
        setActivate(false);
        setMsgArchivo(resp[1]);
        setRetencion([]);
        setDatosArchivo(1);
      } else {
        setHabilitadoBot(true);
        setDatosArchivo(2);
        var reten = cargarCamposArchivo(
          lineas,
          agenteRetencion === true ? 1 : 0
        );
        var total = 0.0;
        var canti = 0;
        for (let x = 0; x < reten.length; x++) {
          canti++;
          total =
            total +
            parseFloat(reten[x].monrete.replace(/\./g, "").replace(",", "."));
        }

        total = Math.round(total * Math.pow(10, 2)) / Math.pow(10, 2);
        setTotalRetenido(
          formatMoneda(
            total.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          )
        );
        setCantidad(canti);
        setRetencion(reten);
        setDeshabilitado(false);
        setActivate(false);
      }
    };
  };

  const renderizarHistorico = () => {
    let age = txtAgente.current.value;
    seleccionarHistorico(age);
  };

  return (
    <div className="">
      <div
        className="p-2 title-table"
        style={{
          fontFamily: "georgia",
          textAlign: "center",
          fontSize: "30px",
          fontWeight: "bold",
        }}
      ></div>
      <div className="container col-md-11 col-12 amanecergris mx-auto">
        <div className="row py-2 col-md-12">
          <div className="col-md-10 mx-auto">
            <div className="card">
              <div className="card-header was-validated">
                <div className="row">
                  <div className="input-group input-group-sm col-md-3">
                    <label
                      htmlFor="idagente"
                      className="form-label input-group-text"
                      id="validationTooltipAgente"
                      style={{ backgroundColor: "#55acee" }}
                    >
                      Código:
                    </label>
                    <input
                      type="text"
                      ref={txtAgente}
                      name="idagente"
                      autoComplete="off"
                      aria-describedby="validationTooltipAgente"
                      onFocus={onFocus}
                      defaultValue={valuess.idagente}
                      placeholder="Código"
                      className="form-control border"
                      onKeyUp={validarAgente}
                      onChange={onChange}
                      required
                    />
                    {habilitadoNU.idagente === true ? (
                      <div
                        className="invalid-tooltip text-center shadow-5-strong"
                        style={{ marginTop: "-3.8rem" }}
                      >
                        Introduzca el Código del Agente.
                      </div>
                    ) : (
                      ""
                    )}
                    <button className="btn btn-info" onClick={handleCatalogo}>
                      <i className="fa fa-search"></i>
                    </button>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">NOMBRES:</label>{" "}
                      &nbsp; {valuess.nombre}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">CÉDULA/RIF:</label>{" "}
                      &nbsp; {valuess.rif}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <ul className="list-group">
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-md-9 input-group input-group-sm">
                        <label className="form-label fw-bold">DIRECCIÓN:</label>{" "}
                        &nbsp; {valuess.direccion}
                      </div>
                      <div className="col-md-3 input-group input-group-sm">
                        <label className="form-label fw-bold">ESTATUS:</label>{" "}
                        &nbsp; {mensajact}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-12 mx-auto">
            <ul
              className="nav nav-tabs mb-2 bg-light"
              id="ex-with-icons"
              role="tablist"
              style={{ borderRadius: "3px 3px 0px 0px" }}
            >
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link estilotab bg-danger"
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#ex-with-icons-tabs-1"
                  role="tab"
                  aria-controls="ex-with-icons-tabs-1"
                  aria-selected="true"
                >
                  <i className="fas fa-pager fa-fw me-1" />
                  Registro de Retenciones
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link estilotab bg-warning"
                  id="ex-with-icons-tab-2"
                  data-mdb-toggle="tab"
                  href="#ex-with-icons-tabs-2"
                  role="tab"
                  aria-controls="ex-with-icons-tabs-2"
                  aria-selected="false"
                >
                  <i className="fas fa-book fa-fw me-1" />
                  Historicos de Retenciones
                </a>
              </li>
            </ul>

            <div className="tab-content" id="ex-with-icons-content">
              <div
                className="tab-pane fade show active"
                id="ex-with-icons-tabs-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="card text-center">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-4 text-center">
                        <h4 className="">PERIODO:</h4>
                      </div>
                      <div
                        className="col-md-4 text-center"
                        style={{ visibility: visibleF }}
                      >
                        <div className="input-group input-group-sm col-md-4 mx-auto">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                            style={{ backgroundColor: "#55acee" }}
                          >
                            Año:
                          </label>
                          <select
                            name="anio"
                            ref={txtAnio}
                            onChange={onChange}
                            className="form-control text-center"
                          >
                            <option value="">--Año--</option>
                            {anio &&
                              anio.map((a) => (
                                <option key={a.anio} value={a.anio}>
                                  {a.anio}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div
                        className="col-md-4 text-center"
                        style={{ visibility: visibleF }}
                      >
                        <div className="input-group input-group-sm col-md-7 mx-auto">
                          <label
                            className="input-group-text"
                            style={{ backgroundColor: "#55acee" }}
                            id="inputGroup-sizing-sm"
                          >
                            Mes:
                          </label>
                          <select
                            ref={txtMes}
                            className="form-control col-md-6 text-center"
                            id="inputStatus"
                            name="mes"
                            onChange={onChange}
                          >
                            <option value="">--Mes--</option>
                            <option value="1">ENERO</option>
                            <option value="2">FEBRERO</option>
                            <option value="3">MARZO</option>
                            <option value="4">ABRIL</option>
                            <option value="5">MAYO</option>
                            <option value="6">JUNIO</option>
                            <option value="7">JULIO</option>
                            <option value="8">AGOSTO</option>
                            <option value="9">SEPTIEMBRE</option>
                            <option value="10">OCTUBRE</option>
                            <option value="11">NOVIEMBRE</option>
                            <option value="12">DICIEMBRE</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body" style={{ visibility: visibleF }}>
                    <div className="col-md-12 row was-validated">
                      <div className="col-md-5 w-100"></div>
                      <div className="col-md-3 mx-auto">
                        <select
                          className="form-select text-center form-select-sm"
                          ref={txtSelect}
                          name="select"
                          onChange={onChange}
                          required
                          aria-label="select example"
                        >
                          <option value="">--Seleccione--</option>
                          <option value={1}>MANUAL</option>
                          <option value={2}>POR ARCHIVO</option>
                        </select>
                        <div
                          className="invalid-tooltip text-center shadow-5-strong"
                          style={{ marginTop: "-4.2rem" }}
                        >
                          Cargar Retenciones.
                        </div>
                      </div>
                      <div className="col-md-4 w-100">
                        <div
                          className="col-md-1 ml-auto"
                          style={{ visibility: visibleA }}
                        >
                          <button
                            onClick={gestionarRetencion(1, "")}
                            style={{ marginBottom: "5px" }}
                            className="btn btn-sm btn-primary rounded-circle"
                          >
                            <i className="fas fa-plus"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row py-2">
                      {select === "0" ? (
                        <div></div>
                      ) : select === "1" ? (
                        <div className="col-md-12">
                          <TblContainer>
                            <TblHead />

                            <TableBody>
                              {
                                /*records && recordsAfterPagingAndSorting().map((item, index) => (*/
                                records &&
                                  records.map((item, index) => (
                                    <TableRow
                                      key={item.index}
                                      style={{ padding: "0" }}
                                    >
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "center" }}
                                      >
                                        {index + 1}
                                      </TableCell>
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "left" }}
                                      >
                                        {item.tipo}
                                      </TableCell>
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.numcontrol}
                                      </TableCell>
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.rif}
                                      </TableCell>
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "left" }}
                                      >
                                        {item.nomcontribuyente}
                                      </TableCell>
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "center" }}
                                      >
                                        {moment(item.fechaemision).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </TableCell>
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "right" }}
                                      >
                                        {formatMoneda(
                                          item.montobruto
                                            .toString()
                                            .replace(",", "")
                                            .replace(".", ","),
                                          ",",
                                          ".",
                                          2
                                        )}
                                      </TableCell>
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "right" }}
                                      >
                                        {formatMoneda(
                                          item.montoretenido
                                            .toString()
                                            .replace(",", "")
                                            .replace(".", ","),
                                          ",",
                                          ".",
                                          2
                                        )}
                                      </TableCell>
                                      <TableCell
                                        className="align-baseline"
                                        style={{ textAlign: "center" }}
                                      >
                                        <button
                                          onClick={gestionarRetencion(
                                            3,
                                            item.idretenciontemp
                                          )}
                                          className="btn btn-sm  btn-danger rounded-circle ml-2"
                                        >
                                          <i className="fa fa-trash"></i>{" "}
                                        </button>
                                      </TableCell>
                                    </TableRow>
                                  ))
                              }
                            </TableBody>
                          </TblContainer>
                          <TableFooter>
                            <TableCell
                              style={{ textAlign: "right", width: "1150px" }}
                            >
                              Total Retenido
                            </TableCell>
                            <TableCell
                              style={{ textAlign: "right", width: "150px" }}
                            >
                              {totalretenido}
                            </TableCell>
                          </TableFooter>
                        </div>
                      ) : select === "2" ? (
                        <div>
                          <div className="col-md-8 mx-auto">
                            <label className="form-label" for="customFile">
                              Carga de Archivo TXT
                            </label>
                            <input
                              type="file"
                              ref={txtFile}
                              accept=".txt"
                              onChange={handleChangeFile}
                              className="form-control"
                              id="customFile"
                            />
                          </div>
                          {datosArchivo === 0 ? (
                            <div></div>
                          ) : datosArchivo === 1 ? (
                            <div>
                              <p
                                style={{
                                  fontFamily: "arial",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                Retenciones Presentes en el Archivo
                              </p>
                              <p
                                style={{
                                  fontFamily: "arial",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                {msgArchivo}
                              </p>
                            </div>
                          ) : (
                            <div className="col-md-12">
                              <TblContainer>
                                <TblHead />
                                <TableBody>
                                  {retencion &&
                                    retencion.map((item, index) => (
                                      <TableRow
                                        key={index}
                                        style={{ padding: "0" }}
                                      >
                                        <TableCell
                                          className="align-baseline"
                                          style={{
                                            textAlign: "center",
                                            width: "120px",
                                          }}
                                        >
                                          {parseInt(item.numope)}
                                        </TableCell>
                                        <TableCell
                                          className="align-baseline"
                                          style={{
                                            textAlign: "left",
                                            width: "170px",
                                          }}
                                        >
                                          {item.tipoins}
                                        </TableCell>
                                        <TableCell
                                          className="align-baseline"
                                          style={{
                                            textAlign: "center",
                                            width: "160px",
                                          }}
                                        >
                                          {item.numins}
                                        </TableCell>
                                        <TableCell
                                          className="align-baseline"
                                          style={{
                                            textAlign: "center",
                                            width: "110px",
                                          }}
                                        >
                                          {item.cedrif}
                                        </TableCell>
                                        <TableCell
                                          className="align-baseline"
                                          style={{
                                            textAlign: "left",
                                            width: "230px",
                                          }}
                                        >
                                          {item.nombre}
                                        </TableCell>
                                        <TableCell
                                          className="align-baseline"
                                          style={{
                                            textAlign: "center",
                                            width: "120px",
                                          }}
                                        >
                                          {item.fecemi}
                                        </TableCell>
                                        <TableCell
                                          className="align-baseline"
                                          style={{
                                            textAlign: "right",
                                            width: "130px",
                                          }}
                                        >
                                          {item.monbruto}
                                        </TableCell>
                                        <TableCell
                                          className="align-baseline"
                                          style={{
                                            textAlign: "right",
                                            width: "150px",
                                          }}
                                        >
                                          {item.monrete}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </TblContainer>
                              <TableFooter>
                                <TableCell
                                  textAlign="right"
                                  style={{ fontWeight: "bold" }}
                                >
                                  Nº de Retenciones:{" "}
                                </TableCell>
                                <TableCell
                                  textAlign="left"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {cantidad}
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "right",
                                    width: "650px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Total Retenido
                                </TableCell>
                                <TableCell
                                  textAlign="right"
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {totalretenido}
                                </TableCell>
                              </TableFooter>
                            </div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="card-footer text-muted">
                    <button
                      /* ref={btnAcepta}  */ disabled={deshabilitado}
                      onClick={procesarRetencion}
                      className="btn btn-sm rounded-pill btn-success col-md-3"
                    >
                      <i className="fas fa-check-circle"> Procesar Retención</i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="ex-with-icons-tabs-2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <div style={{ visibility: visibleF }}>
                  <TablaHistoricoReten
                    tabhist={historico}
                    agente={agente}
                    onHideRenderizar={renderizarHistorico}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AgregarReten
        show={mostrar2}
        operacion={operacion}
        periodo={fechas}
        retencion={retenciontemp}
        agente={agente}
        banco={banco}
        onHideCancela={handleCancela2}
        onHideRenderizar={seleccionarRegistro}
      />

      <CatalogoAgenteTipoEspecifico
        show={catalogo}
        onHideCancelaCatAge={handleCatalogo}
        onHideAceptaCatAge={onHideAceptaCatAge}
      />
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}

export default Retenciones;



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/retencion1x500.js